export function accessTokenClaims(token) {
  try {
    const part = token?.split('.')?.[1];
    if (!part) return null;
    const normalized = part.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=')));
  } catch { return null; }
}

// Access tokens rotate; the signed session ID remains stable for one login session.
// Legacy tokens without sid are bound to their exact token until the user logs in again.
export function accessSessionBinding(token) {
  const claims = accessTokenClaims(token);
  if (typeof claims?.sid === 'string' && claims.sid) return `sid:${claims.sid}`;
  return token ? `legacy-token:${token}` : null;
}
